module.exports = __webpack_public_path__ + "img/4.ff2e4308.png";